import { z } from 'zod';
import { apiFetch } from './api';

// Per-user-per-workspace table-column preferences (TRU-342). The scope
// (userId/workspaceId) is taken from the JWT server-side — never sent from the
// client. The backend is column-agnostic: it stores an opaque ordered id list
// per `tableKey`. The pinned-Email / Coming-Soon / drop-unknown invariants are
// the frontend's job (see features/email-accounts/tanstack/column-preferences.ts).
//
// `GET` returns `columnIds: null` when no row exists (200, not 404) — the
// frontend falls back to the registry defaults in that case.

/** The single shipped table key. Extend the union when a second table opts in. */
export type ColumnTableKey = 'email-accounts';

export const columnPreferenceSchema = z.object({
  tableKey: z.string(),
  columnIds: z.array(z.string()).nullable(),
});

export type ColumnPreference = z.infer<typeof columnPreferenceSchema>;

export async function getColumnPreference(
  tableKey: ColumnTableKey,
): Promise<ColumnPreference> {
  const data = await apiFetch<ColumnPreference>(`/preferences/columns/${tableKey}`);
  return columnPreferenceSchema.parse(data);
}

export async function updateColumnPreference(
  tableKey: ColumnTableKey,
  columnIds: string[],
): Promise<ColumnPreference> {
  const data = await apiFetch<ColumnPreference>(`/preferences/columns/${tableKey}`, {
    method: 'PUT',
    body: JSON.stringify({ columnIds }),
  });
  return columnPreferenceSchema.parse(data);
}
